module.exports = __webpack_public_path__ + "img/vertical_7_4_5012.b2bf1cbb.png";